import { createAction } from '@reduxjs/toolkit';

export const query = createAction('[Agency] query');
export const select = createAction('[Agency] select');
export const clear = createAction('[Agency] clear');
export const keyDown = createAction('[Agency] keyDown');
export const setErrors = createAction('[Agency] setErrors');
